import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { ButtonDirective } from 'primeng/button';
import { NgClass } from '@angular/common';
import { WegweiserStore } from '../../../stores/wegweiser-api/wegweiser.state';
import { DebugComponent } from '../../atoms/debug/debug.component';

@Component({
  selector: 'app-indicator-selection-list',
  standalone: true,
  imports: [ButtonDirective, CdkDrag, CdkDropList, NgClass, DebugComponent],
  templateUrl: './indicator-selection-list.component.html',
  styleUrl: './indicator-selection-list.component.scss',
})
export class IndicatorSelectionListComponent {
  readonly indicatorStore = inject(IndicatorStore);
  readonly wegweiserStore = inject(WegweiserStore);
  @Input() indicatorIds: string[] = [];
  @Input() captions: ({ label: string; icon: string } | null)[] = [];
  @Input() wegweiser!: boolean;
  @Output() dropEvent = new EventEmitter<string[]>();
  @Output() unselectEvent = new EventEmitter<string>();

  /**
   * Handles the drop event for drag-and-drop functionality.
   * Reorders the `indicatorIds` array based on the new positions resulting from the drop action
   * and emits the updated array through the `dropEvent` EventEmitter.
   *
   * @param {CdkDragDrop<string[]>} event - The drop event containing details such as the previous
   *                                         and current indices of the dragged item.
   * @return {void} This method does not return a value.
   */
  onDrop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.indicatorIds, event.previousIndex, event.currentIndex);
    this.dropEvent.emit(this.indicatorIds);
  }

  /**
   * Handles the unselection of an item identified by its indicator ID.
   *
   * @param {string} indicatorId - The unique identifier for the item to be unselected.
   * @return {void} This method does not return any value.
   */
  onUnselect(indicatorId: string): void {
    this.unselectEvent.emit(indicatorId);
  }
}
